var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import styled, { css } from 'styled-components';
import { designSchema } from '../../../../../../../contexts/designs/utils';
import { labelMixin } from '../../styles';
export var Value = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  color: var(--primary-color);\n  font-size: 22px;\n  font-weight: normal;\n  padding-bottom: 8px;\n\n  ", "\n  ", "\n"], ["\n  ", "\n  color: var(--primary-color);\n  font-size: 22px;\n  font-weight: normal;\n  padding-bottom: 8px;\n\n  ", "\n  ", "\n"])), labelMixin, function (_a) {
    var eligibilityCSS = _a.css;
    return css(eligibilityCSS);
}, designSchema);
var templateObject_1;
